// extracted by mini-css-extract-plugin
export var cardLayout = "_70-1";
export var paginationContainer = "_70-0";